import {Button, Card, Col, Modal, Row, Select, Space} from "antd";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {CaretDownFilled} from "@ant-design/icons";
import {useAssignUserVerificationProfile} from "../../../../function/accountVerification";
import {useIsMobile} from "../../../../../../_common/function";
import {countryList_language} from "../../../../../../../config/countryList_language";

function SelectCountry(props) {
    const {selectedCountry, setSelectedCountry, userVerificationProfile, goNext, getUserVerificationFlows} = props

    const {t} = useTranslation();
    const {assignUserVerificationProfile} = useAssignUserVerificationProfile();
    const isMobile = useIsMobile();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const handleSelectCountry = () => {
        if (userVerificationProfile?.country && selectedCountry !== userVerificationProfile?.country) {
            openModal()
        } else {
            goNext()
        }
    }

    const handleChangeCountryFlow = async () => {
        await getUserVerificationFlows({country: selectedCountry});
        goNext()
    }

    return (
        <>
            <div className="verification-hero">
                <h2 className="verification-hero-title mt-4 font-bold text-2xl">{t("accountVerification.letsGetVerified", "Let's Get You Verified")}</h2>
            </div>

            <Card bordered={false} className={"shadow-card"}>
                <Space style={{width: "100%"}} size={16} direction="vertical">
                    <p className={"secondary-text"}>{t("accountVerification.note.selectCountry")}</p>

                    <Row gutter={16} align={"middle"}>
                        <Col flex={1}>
                            <Select
                                style={{width: "100%"}}
                                showSearch
                                placeholder={t("accountVerification.placeholder.selectCountry")}
                                optionFilterProp={"label"}
                                value={selectedCountry}
                                onChange={(country) => setSelectedCountry(country)}
                                suffixIcon={<CaretDownFilled style={{pointerEvents: "none"}}/>}
                                options={countryList_language?.map(d => ({
                                    ...d,
                                    label: t(d?.label),
                                }))}
                            />
                        </Col>
                        <Col span={24}>
                            <Row justify={"end"}>
                                <Button
                                    block={!!isMobile}
                                    disabled={!selectedCountry}
                                    onClick={handleSelectCountry}
                                    className={"mt-4 primary_btn"}
                                >
                                    {t("common.next")}
                                </Button>
                            </Row>
                        </Col>
                    </Row>
                </Space>
            </Card>

            <Modal
                className="verification-modal"
                title={t("Change Country")}
                open={isModalOpen}
                onCancel={closeModal}
                destroyOnClose
                centered
                getContainer="#layout-2"
                footer={
                    <Row justify={"end"} gutter={16}>
                        <Col>
                            <Button className={"secondary_btn"} onClick={closeModal}>{t("common.cancel")}</Button>
                        </Col>
                        <Col>
                            <Button className={"primary_btn"} onClick={handleChangeCountryFlow}>
                                {t("common.confirm")}
                            </Button>
                        </Col>
                    </Row>
                }
            >
                <div>{t("The selected country does not match your profile. Do you wish to continue?")}</div>
            </Modal>
        </>
    );
}

export default SelectCountry;
